import * as React from 'react';
import { useDispatch } from 'react-redux';
import { t, tHtml } from '@moovly/i18n';
import { ModalContainer } from '@moovly/ui';
import { grantUserLicense } from '../store/licenses.store';
import { Subscription } from '../types/subscriptions';
import useUsers from '../../users/hooks/useUsers';
import { Select } from '@moovly/ui';
import { DefaultModalProps } from '../../../types/modal';

interface AssignLicenseModalProps extends DefaultModalProps {
  subscription: Subscription;
}

const AssignLicenseModal: React.FC<AssignLicenseModalProps> = ({ subscription, closeModal, setOpen }) => {
  const { usersWithoutLicense } = useUsers();

  const availableUsers = React.useMemo(
    () =>
      usersWithoutLicense.map((user) => ({
        value: user.id,
        label: `${user.first_name} ${user.name} (${user.email})`,
      })),
    [usersWithoutLicense]
  );

  const dispatch = useDispatch<any>();
  const [userId, setUserId] = React.useState<any>();
  const handleConfirm = React.useCallback(() => {
    if (!subscription) {
      return;
    }
    dispatch(
      grantUserLicense({
        userId: userId,
        licenseId: subscription.id,
        contractId: subscription.contract.id,
      })
    );
    closeModal();
  }, [dispatch, userId, subscription, closeModal]);

  const handleChangeUser = React.useCallback(({ value }: any) => setUserId(value), []);

  return (
    <ModalContainer
      setOpen={setOpen}
      title={t('licenseManagement.modal.grandLicenseToUser.title')}
      onConfirm={handleConfirm}
      confirmDisabled={!userId}
    >
      <>
        {tHtml('licenseManagement.modal.grandLicenseToUser.descriptionText', {
          usersLink: ` <a
            href="/users"
            className="btn btn-link"
          >
            ${t('licenseManagement.modal.grandLicenseToUser.descriptionLink')}
          </a>`,
        })}
        <form onSubmit={handleConfirm}>
          <div className="mb-3">
            <label htmlFor="libraryShareType" className="form-label">
              {t('libraries.table.shareType')}
            </label>
            <Select
              id="libraryShareType"
              placeholder={t('licenseManagement.modal.grandLicenseToUser.searchMember')}
              options={availableUsers}
              value={availableUsers.find((user) => user.value === userId)}
              onChange={handleChangeUser}
            />
          </div>
        </form>
      </>
    </ModalContainer>
  );
};

export default AssignLicenseModal;
